import React from 'react'
import { connect } from 'react-redux'
import {reduxForm, formValueSelector} from 'redux-form'
import validate from './validations/validate'
import asyncValidate from './validations/asyncValidate'
import { CSSTransitionGroup } from 'react-transition-group'
import DeliveryOptions from './components/common/deliveryOptions'
import TimeframeOptions from './components/common/timeframeOptions'
import ShippingInformation from './components/common/shippingInformation'
import SpecializedTranslationOptions from './components/translation/specialized_options'
import TranslationOptions from './components/translation/translations_options'
import AddOns from './components/translation/addons'
import OfficialTranslationOptions from './components/translation/official_options'
import InterpretingOptions from './components/interpreting/interpreting_options'
import CoachingOptions from './components/coaching/coaching_options'
import i18n from './translations/i18n';
import UploadSection from './components/common/upload'

const selector = formValueSelector('davron')


class DavronFormThirdPage extends React.Component {
	constructor(props) {
		super(props);
		this.checkboxChange = this.checkboxChange.bind(this);
		this.shippingAddressRegistered = this.shippingAddressRegistered.bind(this);
	}

	checkboxChange(e) {
		let fields = ['courierServiceDelivery', 'registeredLetterDelivery', 'officeCollectionDelivery', 'trackedLetterDelivery'];
		fields.forEach(value => {
			if (value === e.target.name) { 
				this.props.change(value, true)
			}
			else { this.props.change(value, false) }
		});
	}

	shippingAddressRegistered(data) {
		this.props.shippingAddressChange(data);
		if (data.target.value!=="France") {
			if (this.props.registeredLetterDelivery===true) {
				this.props.change("registeredLetterDelivery", false);
				this.props.change("trackedLetterDelivery", true);
			}

			if (data.target.value!=="United Kingdom" && this.props.courierServiceDelivery===true) {
				this.props.change("registeredLetterDelivery", false);
				this.props.change("trackedLetterDelivery", true);
			}
		}
	}
	
	render() {
		const {handleSubmit, previousPage, service, translationLevel} = this.props
		const lng = this.props.lng;
		const isTranslation = (service==="translation")
		const isOfficial = (service==="official")
		const isInterpreting = (service==="interpreting")
		const isCoaching = (service==="coaching")
		return (
			<form onSubmit={handleSubmit}>
				<CSSTransitionGroup
					transitionName="davron"
					transitionEnterTimeout={500}
					transitionLeaveTimeout={300}
				>	
					{isTranslation&&
					<SpecializedTranslationOptions 
						lng={lng}
						countries={this.props.countries}
						certifications={this.props.certifications}
						totalWords={this.props.totalQty}
					/>}
					{isTranslation&&
					<AddOns 
						lng={lng}
						requestOrigin={this.props.requestOrigin}
						translationLevel={translationLevel}
						certification={this.props.certification}
					/>}
					{isTranslation&&
					<TranslationOptions 
						lng={lng}
						countries={this.props.countries}
						certifications={this.props.certifications}
						totalWords={this.props.totalQty}
					/>}
					{isOfficial&&
					<OfficialTranslationOptions 
						lng={lng}
					/>}
					{isInterpreting&&
					<InterpretingOptions
						lng={lng}
						sourceAvailable={this.props.sourceAvailable}
					/>
					}
					{isCoaching&&
					<CoachingOptions
						lng={lng}
					/>
					}
					{((isTranslation&&this.props.certification)||isOfficial)&&<DeliveryOptions
						lng={this.props.lng}
						courierServices={this.props.courierServices}
						selectedService={this.props.courierServiceDelivery}
						checkboxChange={this.checkboxChange}
						shippingCountry={this.props.shippingCountry}
					/>}
					{(((isTranslation&&this.props.certification)||isOfficial)&&(this.props.courierServiceDelivery||this.props.registeredLetterDelivery||this.props.trackedLetterDelivery))&&<ShippingInformation 
						lng={lng}
						countries={this.props.countries}
						shippingCountry={this.props.shippingCountry}
						deliveryChange={this.props.deliveryChange}
						shippingAddressChange={this.shippingAddressRegistered}
					/>}
					{(isTranslation||isOfficial)&&<TimeframeOptions
						lng={lng}
					/>}
					{isInterpreting&&<div className="form-section">
						<UploadSection 
							lng={lng}
							service="interpreting"
						/>
					</div>}
	
				</CSSTransitionGroup>
				<div>
					<button type="button" className="btn btn-orange previous" onClick={previousPage}>{i18n.t('button.previous', {lng})}</button>
					<button type="submit" className="btn btn-orange next">{i18n.t('button.next', {lng})}</button>
				</div>
			</form>
		)
	}	
}
DavronFormThirdPage = connect(
	(state, props) => ({
		service: selector(state, 'service'),
		totalQty: selector(state, 'totalQty'),
		courierServiceDelivery: selector(state, 'courierServiceDelivery'),
		registeredLetterDelivery: selector(state, 'registeredLetterDelivery'),
		trackedLetterDelivery: selector(state, 'trackedLetterDelivery'),
		translationLevel: selector(state, 'translationLevel'),
		certification: selector(state, 'certification'),
		shippingCountry: selector(state, 'shippingCountry')
	})
)(DavronFormThirdPage)

export default reduxForm({
	form: 'davron',
	destroyOnUnmount: false,
	forceUnregisterOnUnmount: true,
	asyncValidate,
	asyncChangeFields: ['translationLevel', 'certificationOption', 'extraCopies', 'desktopPublishing', 'certification', 'transcreation', 'blockchainCertificate'],
	asyncBlurFields: ['requestOrigin'],
	validate
})(DavronFormThirdPage)


// WEBPACK FOOTER //
// ./src/DavronFormThirdPage.js